import { type PixelCrop } from "react-image-crop";

/** 이미지와 픽셀 크롭 정보를 받아 <img src>로 쓸 URL을 만들어줍니다. */
export const getCroppedImageSrc = async (
  image: HTMLImageElement,
  crop: PixelCrop,
  options?: {
    /** "image/jpeg" | "image/png" 등 */
    type?: string;
    /** JPEG일 때 0~1 */
    quality?: number;
    /** true면 dataURL, false면 Blob URL(object URL) */
    asDataURL?: boolean;
  }
): Promise<string> => {
  const type = options?.type ?? "image/jpeg";
  const quality = options?.quality ?? 0.92;
  const asDataURL = options?.asDataURL ?? false;
  
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  
  const canvas = document.createElement("canvas");
  const dpr = window.devicePixelRatio || 1;
  // 고해상도(레티나) 대응
  canvas.width = Math.floor(crop.width * dpr);
  canvas.height = Math.floor(crop.height * dpr);
  
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("2D context not available");
  
  ctx.scale(dpr, dpr);
  ctx.imageSmoothingQuality = "high";
  
  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );
  
  // 원하는 형식으로 src 반환
  if (asDataURL) {
    return canvas.toDataURL(type, quality); // data:image/jpeg;base64,....
  }
  
  const blob:any = await new Promise((resolve) =>
    canvas.toBlob((b) => resolve(b as Blob), type, quality)
  );
  return blob;
}